export const THEME_BUILDER_API_URL = 'https://wpp-app-theme-builder-api-prd-one.os.wpp.com' || 'http://localhost:8080'
